/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

const CustomerTiersTable = ({ customerTiers, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (customerTiers.loading) {
      return "is Loading";
    }
    if (isEmpty(customerTiers.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Weight</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {customerTiers.data.map(customerTier => (
            <tr key={customerTier.id}>
              <td>{customerTier.id}</td>
              <td>{customerTier.name}</td>
              <td>{customerTier.weight}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/customer-tiers/${customerTier.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(customerTier.id)}
                    to={`/${companyURL}/customer-tiers/${customerTier.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default CustomerTiersTable;
